<template>
  <div :class="$style.container">
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="添加邮箱" name="first">
        <EmailPopup @success="success" />
      </el-tab-pane>
    </el-tabs>
    <div :class="$style.goBack" @click="goBack">返回</div>
  </div>
</template>

<script>
import EmailPopup from "../certify/EmailPopup.vue";

export default {
  name: "SafeEmailAdd",
  components: {
    EmailPopup,
  },
  data() {
    return {
      activeName: "first",
    };
  },
  methods: {
    success() {
      setTimeout(() => {
        this.$router.push("/user/safe");
      }, 1000);
    },
    goBack() {
      this.$router.back();
    },
  },
};
</script>

<style lang="scss" module scoped>
.container {
  position: relative;

  :global {
    .el-tabs {
      box-shadow: $box-shadow;

      ::v-deep .el-tabs__content {
        box-shadow: unset;
      }
      ::v-deep .el-tabs__header {
        background-color: $white;
        border-bottom: $border-1;
      }
    }
  }

  .goBack {
    position: absolute;
    top: 0;
    right: rem(60);
    padding: 10px 5px;
    font-size: rem(14);
    color: #333;
    line-height: 20px;
    cursor: pointer;

    &:hover {
      color: $theme-color;
    }
  }
}
</style>